export default (() => {
  document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-lazy-bg*=http]').forEach(function (el) {
      setTimeout(() => {
        const bgUrl = el.dataset.lazyBg
        el.style.backgroundImage = 'url(' + bgUrl + ')'
      }, 1000)
    })
  })
})()
